import { render, staticRenderFns } from "./ArsipListClaim.vue?vue&type=template&id=66b9e063"
import script from "./ArsipListClaim.vue?vue&type=script&lang=js"
export * from "./ArsipListClaim.vue?vue&type=script&lang=js"
import style0 from "./ArsipListClaim.vue?vue&type=style&index=0&id=66b9e063&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports